import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import DOMPurify from "dompurify";
import { COLORS } from "../../constants";

const MobileAbout = ({ historySections, fourBoxes }) => {
  const sanitizedMarkup = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };
  return (
    <Container sx={{ mt: 4, mb: 4 }} disableGutters>
      {/* Legacy Box */}
      <Box
        sx={{
          backgroundImage: "url(/images/cogs.svg)",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "200px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mb: 4,
          overflow: "hidden",
          color: COLORS.darkText,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontSize: "var(--font-size-l)",
            fontWeight: 600,
            mb: 2,
          }}
        >
          Legacy drives Argus Motors forward.
        </Typography>
        <Box
          sx={{
            backgroundColor: COLORS.themeBlack,
            display: "inline-block",
            px: 3,
            py: 1,
            borderRadius: "8px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: COLORS.themeYellow,
              fontWeight: 500,
              fontSize: "var(--font-size-xs)",
            }}
          >
            Quality parts, trusted service
          </Typography>
        </Box>
      </Box>

      {/* Four Boxes Section */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {fourBoxes.map((box, index) => (
          <Grid key={index} item xs={6}>
            <Box
              sx={{
                backgroundColor: COLORS.white,
                border: `1px solid ${COLORS.border}`,
                borderRadius: "2px",
                px: 2,
                py: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100%",
                minHeight: "120px",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: COLORS.darkText,
                  fontWeight: 500,
                  mb: 1,
                  fontSize: "var(--font-size-xs)",
                }}
              >
                {box.heading}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: COLORS.lightText,
                  fontWeight: box.fontWeight || 300,
                  fontSize: "var(--font-size-xxs)",
                }}
              >
                {box.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* History Section */}
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontSize: "var(--font-size-xl)",
          color: COLORS.darkText,
          textAlign: "center",
        }}
      >
        History
      </Typography>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            width: 2,
            backgroundImage: `linear-gradient(to bottom, transparent 50%, ${
              COLORS.gray || "#ccc"
            } 50%)`,
            backgroundSize: "2px 8px",
            zIndex: 1,
          }}
        />
        {historySections.map((section, index) => (
          <Box
            key={index}
            sx={{
              mb: 4,
              display: "flex",
              alignItems: "flex-start",
              position: "relative",
              "&:last-child": { mb: 0 },
            }}
          >
            {/* Timeline Dot and Line */}
            <Box
              sx={{
                width: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                ml: -2.4,
              }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  backgroundColor: COLORS.themeYellow,
                  border: `4px solid ${COLORS.themeBlack}`,
                  borderRadius: "50%",
                  zIndex: 2,
                  mt: "8px",
                }}
              />
            </Box>
            {/* Content */}
            <Box sx={{ flex: 1, pl: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Typography
                  variant="h6"
                  sx={{
                    mr: 1,
                    color: COLORS.darkText,
                    fontSize: "var(--font-size-m)",
                  }}
                >
                  {section.year} -
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 300,
                    fontSize: "var(--font-size-m)",
                    color: COLORS.darkText,
                  }}
                >
                  {section.title}
                </Typography>
              </Box>
              <img
                src={section.image}
                alt={section.title}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  mb: 2,
                }}
              />
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: "var(--font-size-xxs)", textAlign: "justify" }}
                dangerouslySetInnerHTML={sanitizedMarkup(section.text)}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default MobileAbout;
